import env from '../config/env';
import { getService, postBodyService } from "./base.service";
import config from "../config/application";
import permission from '../api/permissions.service';
import dictionary from '../config/dictionary';
//url
const readLimitAmountEntity = 'find_all/';
const createLimitAmountEntity = 'add';
const deleteLimitAmountEntity = 'delete';
const updateLimitAmountEntity = 'update';

class LimitAmountEntityService {
    async getLimitAmountEntity(username, entity, society) {
        let valid = await permission.validPermission(
            env.transaction.limitAmount,
            username,
            env.app.systemCode, dictionary.configApp.action.list);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.income.limitAmountEntity.url}${readLimitAmountEntity}${entity}/${society}`;
            return getService(url);
        } else {
            return valid;
        }
    }
    async getCreateLimitAmountEntity(limitAmountEntity, username) {
        let valid = await permission.validPermission(
            env.transaction.limitAmount,
            username,
            env.app.systemCode, dictionary.configApp.action.add);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.income.limitAmountEntity.url}${createLimitAmountEntity}`;
            return postBodyService(url, limitAmountEntity);
        } else {
            return valid;
        }
    }
    async getDeleteLimitAmountEntity(lsData, username) {
        let valid = await permission.validPermission(
            env.transaction.limitAmount,
            username,
            env.app.systemCode, dictionary.configApp.action.delete);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.income.limitAmountEntity.url}${deleteLimitAmountEntity}`;
            return postBodyService(url, lsData);
        } else {
            return valid;
        }
    }
    async getUpdateLimitAmountEntity(limitAmountEntity, username) {
        let valid = await permission.validPermission(
            env.transaction.limitAmount,
            username,
            env.app.systemCode, dictionary.configApp.action.edit);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.income.limitAmountEntity.url}${updateLimitAmountEntity}`;

            return postBodyService(url, limitAmountEntity);
        } else {
            return valid;
        }
    }
}
export default new LimitAmountEntityService();